<template>
  <div>
    <div class="header" v-if="$app.header">
      <a href="javascript:void(0)" @click="goBack" v-if="isBack">
        <img src="../../assets/mobile/nav-fanhui@2x.png">
      </a>
      <h3>{{title}}</h3>
    </div>
    <div v-if="!$app.header" class="navbar-space">
    </div>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-navbar.scss");
export default {
  data() {
    return {};
  },
  props: {
    title: String,
    isBack: Boolean
  },
  methods: {
    goBack() {
      window.history.back();
    }
  }
};
</script>

